import { PureComponent } from 'react';

import { acceptInvitation } from '../api/invitations';

import Input from '../components/input/input';

class Invitation extends PureComponent {
  state = {
    password: '',
    isValid: true,
    errors: null,
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async onSubmit() {
    const { password } = this.state;
    const { match, onSignIn } = this.props;

    if (this.isValid()) {
      const user = await acceptInvitation({
        token: match.params.token,
        password,
      });

      await onSignIn({
        data: { email: user.invitation.email, password },
        redirectTo: '/profile',
      });
    } else {
      this.setState({ isValid: this.isValid() });
      window.scrollTo(0, 0);
    }
  }

  isValid() {
    const { password, confirmPassword } = this.state;
    return password !== '' && confirmPassword !== '';
  }

  render() {
    const { confirmPassword, password, isValid, errors } = this.state;

    const messageBox = errors && (
      <div className="errors">
        {errors &&
          errors.map((error, index) => (
            <span key={index}>{error.message}</span>
          ))}
      </div>
    );

    return (
      <main className="th-main">
        <section className="th-canvas">
          <header className="th-canvas-header"></header>
          <div>
            <div className="auth">
              <div className="header">
                <h1>Invitation</h1>
              </div>
              {messageBox}
              <div className="w-100 flex flex-column items-start justify-between mt10">
                <div className="w-100">
                  <Input
                    name="password"
                    type="password"
                    label="Choose a password for signing in to SleepDoctor*"
                    value={password}
                    valid={isValid || password !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
                <div className="w-100">
                  <Input
                    name="confirmPassword"
                    type="password"
                    label="Confirm password"
                    value={confirmPassword}
                    valid={isValid || confirmPassword !== ''}
                    onChange={(event) => this.onChange(event)}
                  />
                </div>
              </div>
              <div className="action">
                <button
                  className="btn-green"
                  data-cy="submit"
                  onClick={() => this.onSubmit()}
                >
                  Continue to SleepDoctor
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default Invitation;
